import { _ as __rest, a as __assign } from './tslib.es6-ff7ae7b8.js';
import * as React from 'react';

function ChevronDownIcon(_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.23713 6.42024C2.79745 5.85992 3.7059 5.85992 4.26622 6.42024L12.8169 14.9709L21.3676 6.42024C21.9279 5.85992 22.8363 5.85992 23.3967 6.42024C23.957 6.98056 23.957 7.88901 23.3967 8.44933L13.8314 18.0145C13.2711 18.5749 12.3627 18.5749 11.8024 18.0145L2.23713 8.44933C1.67682 7.88901 1.67682 6.98056 2.23713 6.42024Z", fill: fillColor })));
}

export { ChevronDownIcon as C };
